
  import ipxRuntime$c5bYuDBMFn7pLf3NiYFFTgAhjpBXVLzp5UXALzaMXO0 from '/app/node_modules/@nuxt/image/dist/runtime/providers/ipx'
  
  export const imageOptions = {
    ...{
  "screens": {
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "2xl": 1536,
    "xs": 320
  },
  "presets": {
    "hero": {
      "modifiers": {
        "format": "webp",
        "quality": 82,
        "fit": "cover"
      }
    },
    "product": {
      "modifiers": {
        "format": "webp",
        "quality": 85,
        "fit": "inside",
        "background": "transparent"
      }
    },
    "productCard": {
      "modifiers": {
        "format": "webp",
        "quality": 82,
        "fit": "inside",
        "background": "transparent"
      }
    },
    "logo": {
      "modifiers": {
        "format": "webp",
        "quality": 85,
        "fit": "inside",
        "background": "transparent"
      }
    },
    "thumbnail": {
      "modifiers": {
        "format": "webp",
        "quality": 80,
        "fit": "inside",
        "background": "transparent"
      }
    }
  },
  "provider": "ipx",
  "domains": [
    "api.novartshop.ro",
    "novartshop.ro",
    "centrudetelefoane.ro",
    "www.centru-de-telefoane.ro"
  ],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp",
    "avif",
    "webp"
  ],
  "quality": 80
},
    /** @type {"ipx"} */
    provider: "ipx",
    providers: {
        ['ipx']: { setup: ipxRuntime$c5bYuDBMFn7pLf3NiYFFTgAhjpBXVLzp5UXALzaMXO0, defaults: {} }
    }
  }
